export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const validatePhoneNumber = (phoneNumber) => {
  const regex = /^(?:\+?61|0)(?:\d{9}|\d{2}\s?\d{4}\s?\d{4})$/;
  return regex.test(phoneNumber);
};
